import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { classNames } from "./utils";

interface TabNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export function TabNavigation({ activeTab, onTabChange }: TabNavigationProps) {
  const navigate = useNavigate();
  const { phoneNumber } = useParams<{ phoneNumber?: string }>();
  
  const tabs = [
    { id: "messages", label: "WhatsApp Messages", path: "messages" },
    { id: "whatsapp-calls", label: "WhatsApp Calls", path: "whatsappcalls" },
    { id: "phone-calls", label: "Phone Calls", path: "phonecalls" },
    { id: "insights", label: "Insights", path: "insights" },
    { id: "recommendations", label: "Recommendations", path: "recommendations" },
  ];

  const handleTabClick = (tab: { id: string; path: string }) => {
    if (phoneNumber) {
      // Navigate to the tab-specific route
      navigate(`/events/whatsapp-send-message/${phoneNumber}/${tab.path}`);
    } else {
      // Fallback to old behavior if no phoneNumber in URL
      onTabChange(tab.id);
    }
  };

  return (
    <div className="border-b bg-white">
      <div className="flex space-x-1 px-4">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => handleTabClick(tab)}
            className={classNames(
              "px-4 py-3 text-sm font-medium transition-colors border-b-2",
              activeTab === tab.id
                ? "border-blue-500 text-blue-600"
                : "border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300"
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>
    </div>
  );
}

